// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"f714d028","337":"bcb3edba"}[chunkId] + ".chunk.js";
};